<template>
<div>
  <v-layout>
    <v-flex xs12 style="position:relative">
      <v-select v-if="editable" v-model="model" :items="field.values" :label="field.name" item-text="value"
                item-value="key"
                multiple></v-select>
      <!-- <v-text-field v-if="editable" v-model="model" :landscape="true"></v-text-field> -->
      <div v-else>
        <span v-if="isBaseValid()">
          {{ getCustomPresentationValue(model) }}
        </span>

        <v-tooltip v-else top>
          <template v-slot:activator=" { on }">
            <span ref="span" v-on="on">{{ getCustomPresentationValue(model) | notEmpty }}</span>
          </template>
          <span>{{ validation.message }}</span>
        </v-tooltip>

      </div>
      <v-icon style="position:absolute;top:5px;right:-30px;cursor:pointer;z-index:2000" @click="updateOrigin" v-if="isEdited() && editable" class="light-green--text">check</v-icon>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import {
  input
} from '@/mixins/input'
import InputHelper from '@/plugins/InputHelper'
export default {
  mixins: [input],
  props: ["valueField", "editable", "field", "validation", "context"],
  data() {
    return {
      valueToShow: ""
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  watch: {
    editable: function(newVal) {
      if (!newVal && this.isEdited())
        this.reset();
    },
    valueField: function(newVal) {
      this.valueToShow = newVal
      this.model = this.setUpModel(newVal)
    }
  },
  created() {
    this.model = this.setUpModel(this.valueField)
    this.valueToShow = this.valueField
  },
  methods: {
    isBaseValid() {
      return true //this.validation.pass
    },
    setUpModel(value) {
      return Array.isArray(this.valueField) ? value : []
    },
    updateOrigin() {

      this.$emit("updateField", this.model)
    },
    isEdited() {
      return this.valueField != this.model
    },
    reset() {
      this.model = this.setUpModel(this.valueField)
    },
    getCustomPresentationValue(model) {
      return InputHelper.getCheckboxStringValues(this.field, model)
    },
  },
}
</script>

<style scope>
.radio>label {
  font-size: 11px !important;
}
</style>
